/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MegaphoneIcon24Solid = forwardRef('MegaphoneIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4 7h5.209c2.455-.287 4.831-1.568 7.487-4.073C17.875 1.815 20 2.547 20 4.301v14.398c0 1.755-2.125 2.486-3.304 1.374-2.657-2.506-5.034-3.787-7.49-4.073H4a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3Z" }),
        React.createElement("path", { d: "M10 21v-4H5v4a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2Z" }),
        React.createElement("path", { d: "M22.125 8.902A.75.75 0 0 0 21 9.55v3.898a.75.75 0 0 0 1.125.65 2.999 2.999 0 0 0 0-5.197Z" })));
});
